(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["nov-page-faqs"]) return;
  try {
    
  (function () {
    document.querySelectorAll('.page-faqs__tabs-root[data-tabs-active="true"]').forEach(function (root) {
      var tabs = root.querySelectorAll('[data-faq-tab]');
      var panels = root.querySelectorAll('[data-faq-panel]');
      function activate(key) {
        tabs.forEach(function (tab) {
          var on = tab.getAttribute('data-faq-tab') === key;
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
          tab.classList.toggle('page-faqs__pill--active', on);
          tab.tabIndex = on ? 0 : -1;
        });
        panels.forEach(function (panel) {
          var on = panel.getAttribute('data-faq-panel') === key;
          panel.hidden = !on;
          panel.classList.toggle('is-active', on);
        });
      }
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          activate(tab.getAttribute('data-faq-tab'));
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nov-product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
            Currency.convertAll(shopCurrency, $('#currencies span.selected').attr('data-currency'));
          })
          .catch(e => {
            console.error(e);
          });
      }
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["owt-cb-detail-viewer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('owt-cb-detail-viewer')) return;

    class OwtCbDetailViewer extends HTMLElement {
      #stage = null;
      #heroMount = null;
      #heroFit = null;
      #heroImg = null;
      #zoomHit = null;
      #lens = null;
      #dialog = null;
      #dialogImg = null;
      #dialogViewport = null;
      #zoomSrc = '';
      #zoomLevel = 2;
      #finePointer = false;
      #reduceMotion = false;
      #resizeObserver = null;
      #layoutFrame = null;
      #lensFrame = null;
      #lensVisible = false;
      #pointerTap = { x: 0, y: 0, t: 0, moved: false, pointerId: null };
      #lastDialogTap = 0;

      #pinch = {
        scale: 1,
        min: 1,
        max: 6,
        lastDist: 0,
        panX: 0,
        panY: 0,
        startPanX: 0,
        startPanY: 0,
        startX: 0,
        startY: 0,
        active: false
      };

      connectedCallback() {
        this.#stage = this.querySelector('.owt-cb-detail-viewer__stage');
        if (!this.#stage) return;

        this.#heroMount = this.#stage.querySelector('.owt-cb-detail-viewer__hero-mount');
        this.#heroFit = this.#stage.querySelector('.owt-cb-detail-viewer__hero-fit');
        this.#heroImg = this.#stage.querySelector('.owt-cb-detail-viewer__hero-img');
        this.#zoomHit = this.#stage.querySelector('[data-zoom-hit]');
        this.#lens = this.#stage.querySelector('[data-lens]');

        const section = this.closest('.owt-cb-detail-viewer');
        this.#dialog = section?.querySelector('[data-detail-dialog]') ?? null;
        this.#dialogImg = section?.querySelector('.owt-cb-detail-viewer__dialog-img') ?? null;
        this.#dialogViewport = section?.querySelector('[data-detail-viewport]') ?? null;

        this.#zoomSrc = this.dataset.zoomSrc || '';
        const zoomRaw = parseFloat(this.dataset.zoomLevel || '20') || 20;
        this.#zoomLevel = zoomRaw > 5 ? zoomRaw / 10 : zoomRaw;
        this.#finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
        this.#reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const macroFallback = section?.querySelector('[data-macro-fallback]');
        if (this.#reduceMotion && macroFallback) {
          macroFallback.hidden = false;
        }

        this.#bindLayoutListeners();
        this.#scheduleLayout();

        if (this.#zoomSrc) {
          if (this.#lens) {
            this.#lens.style.backgroundImage = `url("${this.#zoomSrc}")`;
          }
          this.#initZoomSurface();
          if (!this.#reduceMotion) {
            if (this.#finePointer) {
              this.#initHoverLens();
            }
            this.#initTouchLens();
          }
          this.#initDialogTriggers();
        }
      }

      disconnectedCallback() {
        this.#resizeObserver?.disconnect();
        if (this.#layoutFrame != null) window.cancelAnimationFrame(this.#layoutFrame);
        if (this.#lensFrame != null) window.cancelAnimationFrame(this.#lensFrame);
      }

      #initDialogTriggers() {
        const section = this.closest('.owt-cb-detail-viewer');
        const openers = [];
        if (section) {
          openers.push(...section.querySelectorAll('[data-detail-open]'));
        }

        for (const el of openers) {
          el.addEventListener('click', () => this.#openDialog());
        }

        if (this.#zoomHit) {
          this.#zoomHit.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              this.#openDialog();
            }
          });
          this.#zoomHit.addEventListener('click', (e) => {
            if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
            this.#openDialog();
          });
        }

        this.#dialog?.querySelector('[data-detail-close]')?.addEventListener('click', () => this.#closeDialog());
        this.#dialog?.addEventListener('click', (e) => {
          if (e.target === this.#dialog) this.#closeDialog();
        });
        this.#dialog?.addEventListener('cancel', (e) => {
          e.preventDefault();
          this.#closeDialog();
        });
      }

      #openDialog() {
        if (!this.#dialog || !this.#dialogImg) return;
        if (this.#dialog.open) return;
        if (this.#zoomSrc && !this.#dialogImg.getAttribute('src')) {
          this.#dialogImg.src = this.#zoomSrc;
        }
        this.#resetPinch();
        this.#dialog.showModal();
        this.#initPinchPan();
        this.#dialog.querySelector('[data-detail-close]')?.focus();
      }

      #closeDialog() {
        if (!this.#dialog?.open) return;
        this.#dialog.close();
        this.#teardownPinchPan();
      }

      #resetPinch() {
        this.#pinch.scale = 1;
        this.#pinch.panX = 0;
        this.#pinch.panY = 0;
        this.#applyPinchTransform();
      }

      #applyPinchTransform() {
        if (!this.#dialogImg) return;
        this.#dialogImg.style.transform = `translate(${this.#pinch.panX}px, ${this.#pinch.panY}px) scale(${this.#pinch.scale})`;
      }

      #initPinchPan() {
        const vp = this.#dialogViewport;
        if (!vp) return;

        this.#onTouchStart = (e) => this.#handleTouchStart(e);
        this.#onTouchMove = (e) => this.#handleTouchMove(e);
        this.#onTouchEnd = () => this.#handleTouchEnd();

        vp.addEventListener('touchstart', this.#onTouchStart, { passive: false });
        vp.addEventListener('touchmove', this.#onTouchMove, { passive: false });
        vp.addEventListener('touchend', (e) => {
          this.#handleTouchEnd();
          if (e.changedTouches.length === 1 && !this.#pinch.active) {
            const now = Date.now();
            if (now - this.#lastDialogTap < 320) {
              this.#pinch.scale = this.#pinch.scale > 1.5 ? 1 : Math.min(this.#pinch.max, 2.5);
              this.#applyPinchTransform();
              this.#lastDialogTap = 0;
            } else {
              this.#lastDialogTap = now;
            }
          }
        });
        vp.addEventListener('touchcancel', this.#onTouchEnd);
      }

      #teardownPinchPan() {
        const vp = this.#dialogViewport;
        if (!vp || !this.#onTouchStart) return;
        vp.removeEventListener('touchstart', this.#onTouchStart);
        vp.removeEventListener('touchmove', this.#onTouchMove);
        vp.removeEventListener('touchend', this.#onTouchEnd);
        vp.removeEventListener('touchcancel', this.#onTouchEnd);
      }

      #onTouchStart = null;
      #onTouchMove = null;
      #onTouchEnd = null;

      #touchDistance(touches) {
        if (touches.length < 2) return 0;
        const dx = touches[0].clientX - touches[1].clientX;
        const dy = touches[0].clientY - touches[1].clientY;
        return Math.hypot(dx, dy);
      }

      #handleTouchStart(e) {
        const touches = e.touches;
        if (touches.length === 2) {
          this.#pinch.active = true;
          this.#pinch.lastDist = this.#touchDistance(touches);
          e.preventDefault();
        } else if (touches.length === 1 && this.#pinch.scale > 1) {
          this.#pinch.startX = touches[0].clientX;
          this.#pinch.startY = touches[0].clientY;
          this.#pinch.startPanX = this.#pinch.panX;
          this.#pinch.startPanY = this.#pinch.panY;
          e.preventDefault();
        }
      }

      #handleTouchMove(e) {
        const touches = e.touches;
        if (touches.length === 2 && this.#pinch.active) {
          const dist = this.#touchDistance(touches);
          if (this.#pinch.lastDist > 0) {
            const next = this.#pinch.scale * (dist / this.#pinch.lastDist);
            this.#pinch.scale = Math.min(this.#pinch.max, Math.max(this.#pinch.min, next));
            this.#applyPinchTransform();
          }
          this.#pinch.lastDist = dist;
          e.preventDefault();
        } else if (touches.length === 1 && this.#pinch.scale > 1) {
          this.#pinch.panX = this.#pinch.startPanX + (touches[0].clientX - this.#pinch.startX);
          this.#pinch.panY = this.#pinch.startPanY + (touches[0].clientY - this.#pinch.startY);
          this.#applyPinchTransform();
          e.preventDefault();
        }
      }

      #handleTouchEnd() {
        this.#pinch.active = false;
        this.#pinch.lastDist = 0;
        if (this.#pinch.scale <= 1.02) {
          this.#resetPinch();
        }
      }

      #initZoomSurface() {
        if (!this.#zoomHit || !this.#heroImg) return;
        this.#zoomHit.hidden = false;
        this.#zoomHit.setAttribute('tabindex', '0');
        this.#positionZoomHit();
      }

      #showLens() {
        if (!this.#lens) return;
        this.#lensVisible = true;
        this.#lens.hidden = false;
        this.#lens.classList.add('is-active');
        this.#lens.setAttribute('aria-hidden', 'false');
      }

      #hideLens() {
        if (!this.#lens) return;
        this.#lensVisible = false;
        this.#lens.hidden = true;
        this.#lens.classList.remove('is-active');
        this.#lens.setAttribute('aria-hidden', 'true');
      }

      #initHoverLens() {
        if (!this.#zoomHit || !this.#lens || !this.#heroImg) return;

        this.#zoomHit.addEventListener('pointerenter', (e) => {
          if (e.pointerType !== 'mouse') return;
          this.#showLens();
        });
        this.#zoomHit.addEventListener('pointerleave', (e) => {
          if (e.pointerType !== 'mouse') return;
          this.#hideLens();
        });
        this.#zoomHit.addEventListener('pointermove', (e) => {
          if (e.pointerType !== 'mouse' || !this.#lensVisible) return;
          this.#moveLens(e);
        });
      }

      #initTouchLens() {
        if (!this.#zoomHit || !this.#lens || !this.#heroImg) return;

        this.#zoomHit.addEventListener('pointerdown', (e) => {
          if (e.pointerType === 'mouse' && this.#finePointer) return;
          this.#pointerTap = {
            x: e.clientX,
            y: e.clientY,
            t: Date.now(),
            moved: false,
            pointerId: e.pointerId
          };
          this.#showLens();
          this.#moveLens(e);
          this.#zoomHit.setPointerCapture(e.pointerId);
        });

        this.#zoomHit.addEventListener('pointermove', (e) => {
          if (this.#pointerTap.pointerId !== e.pointerId) return;
          if (Math.hypot(e.clientX - this.#pointerTap.x, e.clientY - this.#pointerTap.y) > 10) {
            this.#pointerTap.moved = true;
          }
          this.#moveLens(e);
        });

        const endTouchPointer = (e) => {
          if (this.#pointerTap.pointerId !== e.pointerId) return;
          this.#hideLens();
          try {
            this.#zoomHit.releasePointerCapture(e.pointerId);
          } catch {
            /* pointer already released */
          }
          if (!this.#pointerTap.moved && Date.now() - this.#pointerTap.t < 450) {
            this.#openDialog();
          }
          this.#pointerTap.pointerId = null;
        };

        this.#zoomHit.addEventListener('pointerup', endTouchPointer);
        this.#zoomHit.addEventListener('pointercancel', endTouchPointer);
      }

      #moveLens(e) {
        if (!this.#lensVisible || !this.#lens || !this.#zoomHit) return;
        if (this.#lensFrame != null) window.cancelAnimationFrame(this.#lensFrame);
        this.#lensFrame = window.requestAnimationFrame(() => {
          this.#lensFrame = null;
          const stageRect = this.#stage.getBoundingClientRect();
          const hitRect = this.#zoomHit.getBoundingClientRect();
          const lensSize = this.#lens.offsetWidth || 160;
          const half = lensSize / 2;

          let left = e.clientX - stageRect.left - half;
          let top = e.clientY - stageRect.top - half;
          const maxLeft = stageRect.width - lensSize;
          const maxTop = stageRect.height - lensSize;
          left = Math.max(0, Math.min(maxLeft, left));
          top = Math.max(0, Math.min(maxTop, top));

          this.#lens.style.left = `${left}px`;
          this.#lens.style.top = `${top}px`;

          const px = ((e.clientX - hitRect.left) / hitRect.width) * 100;
          const py = ((e.clientY - hitRect.top) / hitRect.height) * 100;
          const bgSize = this.#zoomLevel * 100;
          this.#lens.style.backgroundSize = `${bgSize}%`;
          this.#lens.style.backgroundPosition = `${px}% ${py}%`;
        });
      }

      #positionZoomHit() {
        if (!this.#zoomHit || !this.#heroImg) return;
        const img = this.#heroImg;
        if (!img.complete) {
          img.addEventListener('load', () => this.#positionZoomHit(), { once: true });
          return;
        }
        const stageRect = this.#stage.getBoundingClientRect();
        const imgRect = img.getBoundingClientRect();
        if (imgRect.width <= 0 || imgRect.height <= 0) return;

        this.#zoomHit.style.left = `${imgRect.left - stageRect.left}px`;
        this.#zoomHit.style.top = `${imgRect.top - stageRect.top}px`;
        this.#zoomHit.style.width = `${imgRect.width}px`;
        this.#zoomHit.style.height = `${imgRect.height}px`;
        this.#zoomHit.hidden = false;
      }

      #bindLayoutListeners() {
        window.addEventListener('resize', () => this.#scheduleLayout(), { passive: true });
        if (typeof ResizeObserver !== 'undefined') {
          this.#resizeObserver = new ResizeObserver(() => this.#scheduleLayout());
          this.#resizeObserver.observe(this.#stage);
          const stageWrap = this.closest('.owt-cb-detail-viewer__stage-wrap');
          if (stageWrap) this.#resizeObserver.observe(stageWrap);
          const grid = this.closest('.owt-cb-detail-viewer__grid');
          if (grid) this.#resizeObserver.observe(grid);
        }
        if (this.#heroImg instanceof HTMLImageElement && !this.#heroImg.complete) {
          this.#heroImg.addEventListener('load', () => this.#scheduleLayout(), { once: true });
        }
      }

      #scheduleLayout() {
        if (this.#layoutFrame != null) window.cancelAnimationFrame(this.#layoutFrame);
        this.#layoutFrame = window.requestAnimationFrame(() => {
          this.#layoutFrame = window.requestAnimationFrame(() => {
            this.#layoutFrame = null;
            this.#positionZoomHit();
          });
        });
      }
    }

    customElements.define('owt-cb-detail-viewer', OwtCbDetailViewer);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["owt-color-changer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('owt-color-changer')) return;

    class OwtColorChanger extends HTMLElement {
      #stage = null;
      #stageWrap = null;
      #imgs = [];
      #buttons = [];
      #valid = [];
      #active = 0;
      #timer = null;
      #cyclePos = 0;
      #paused = false;
      #reduceMotion = false;
      #onPointerEnter = null;
      #onPointerLeave = null;
      #onVisibility = null;

      connectedCallback() {
        this.#stage = this.querySelector('.owt-color-changer__stage');
        this.#stageWrap = this.querySelector('.owt-color-changer__stage-wrap');
        if (!this.#stage || !this.#stageWrap) return;

        this.#reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.#imgs = Array.from(this.#stage.querySelectorAll('.owt-color-changer__topper-img[data-topper-index]'));
        this.#buttons = Array.from(this.#stageWrap.querySelectorAll('.owt-color-changer__swatch[data-swatch-index]'));
        this.#valid = this.#imgs
          .map((img) => parseInt(img.getAttribute('data-topper-index'), 10))
          .filter((n) => !Number.isNaN(n))
          .sort((a, b) => a - b);

        if (this.#valid.length === 0) return;

        let initial = parseInt(this.dataset.initialIndex || '0', 10);
        if (!this.#valid.includes(initial)) {
          initial = this.#valid[0];
        }
        this.#active = initial;
        this.#cyclePos = Math.max(0, this.#valid.indexOf(initial));

        this.#syncImages(false);
        this.#syncButtons();
        this.#updateLiveRegion();

        for (const btn of this.#buttons) {
          btn.addEventListener('click', this.#onSwatchClick);
        }

        if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
          for (const btn of this.#buttons) {
            btn.addEventListener('pointerenter', this.#onSwatchPointerEnter);
          }
        }

        this.#onPointerEnter = () => {
          this.#paused = true;
          this.#stopCycle();
        };
        this.#onPointerLeave = () => {
          this.#paused = false;
          this.#maybeStartCycle();
        };
        this.#stageWrap.addEventListener('pointerenter', this.#onPointerEnter);
        this.#stageWrap.addEventListener('pointerleave', this.#onPointerLeave);

        this.#onVisibility = () => {
          if (document.hidden) {
            this.#stopCycle();
          } else {
            this.#maybeStartCycle();
          }
        };
        document.addEventListener('visibilitychange', this.#onVisibility);

        this.#maybeStartCycle();
      }

      disconnectedCallback() {
        this.#stopCycle();
        if (this.#stageWrap && this.#onPointerEnter && this.#onPointerLeave) {
          this.#stageWrap.removeEventListener('pointerenter', this.#onPointerEnter);
          this.#stageWrap.removeEventListener('pointerleave', this.#onPointerLeave);
        }
        if (this.#onVisibility) {
          document.removeEventListener('visibilitychange', this.#onVisibility);
        }
        for (const btn of this.#buttons) {
          btn.removeEventListener('click', this.#onSwatchClick);
          btn.removeEventListener('pointerenter', this.#onSwatchPointerEnter);
        }
      }

      #onSwatchClick = (e) => {
        const btn = e.currentTarget;
        const idx = parseInt(btn.getAttribute('data-swatch-index'), 10);
        if (Number.isNaN(idx)) return;
        if (!this.#valid.includes(idx)) return;
        this.#cyclePos = this.#valid.indexOf(idx);
        this.#setActive(idx);
      };

      #onSwatchPointerEnter = (e) => {
        const btn = e.currentTarget;
        const idx = parseInt(btn.getAttribute('data-swatch-index'), 10);
        if (Number.isNaN(idx)) return;
        if (!this.#valid.includes(idx)) return;
        this.#setActive(idx);
      };

      #setActive(index) {
        if (this.#active === index && this.#imgs.some((img) => img.classList.contains('is-active'))) return;
        this.#active = index;
        this.#syncImages(!this.#reduceMotion);
        this.#syncButtons();
        this.#updateLiveRegion();
      }

      #syncImages(animate) {
        const fade = this.#stage.dataset.fadeDuration || '280';
        const dropOn = this.#stage.dataset.dropAnimation === 'true';
        const dropMsRaw = this.#stage.dataset.dropMs || '580';
        const dropMs = Number.parseInt(dropMsRaw, 10);
        this.#stage.style.setProperty('--owt-cc-fade', animate ? `${fade}ms` : '0ms');
        this.#stage.style.setProperty('--owt-cc-drop-ms', `${Number.isNaN(dropMs) ? 580 : dropMs}ms`);

        for (const img of this.#imgs) {
          img.classList.remove('is-active', 'owt-color-changer__topper-img--settled');
        }

        const activeImg = this.#imgs.find((img) => {
          const idx = parseInt(img.getAttribute('data-topper-index'), 10);
          return idx === this.#active;
        });

        if (!activeImg) {
          window.requestAnimationFrame(() => {
            this.#stage.style.setProperty('--owt-cc-fade', `${fade}ms`);
          });
          return;
        }

        const instant = !animate || this.#reduceMotion;
        const useDrop = dropOn && animate && !this.#reduceMotion;

        if (instant) {
          activeImg.classList.add('is-active', 'owt-color-changer__topper-img--settled');
        } else if (useDrop) {
          void activeImg.offsetWidth;
          activeImg.classList.add('is-active');
        } else {
          activeImg.classList.add('is-active');
        }

        window.requestAnimationFrame(() => {
          this.#stage.style.setProperty('--owt-cc-fade', `${fade}ms`);
        });
      }

      #syncButtons() {
        for (const btn of this.#buttons) {
          const idx = parseInt(btn.getAttribute('data-swatch-index'), 10);
          btn.setAttribute('aria-pressed', idx === this.#active ? 'true' : 'false');
        }
      }

      #updateLiveRegion() {
        const wrap = this.#stage.querySelector('[data-live-label]');
        if (!wrap) return;
        const live = wrap.querySelector('[data-live-region]');
        const activeBtn = this.#buttons.find((b) => parseInt(b.getAttribute('data-swatch-index'), 10) === this.#active);
        if (live && activeBtn) {
          live.textContent = activeBtn.getAttribute('aria-label') || '';
        }
      }

      #maybeStartCycle() {
        this.#stopCycle();
        if (this.#paused || document.hidden) return;
        if (this.dataset.autoCycle !== 'true') return;
        if (this.#reduceMotion) return;
        if (this.#valid.length < 2) return;

        const interval = parseInt(this.dataset.cycleInterval || '2500', 10);
        if (Number.isNaN(interval) || interval < 1000) return;

        this.#timer = window.setInterval(() => {
          if (this.#paused || document.hidden) return;
          this.#cyclePos = (this.#cyclePos + 1) % this.#valid.length;
          const next = this.#valid[this.#cyclePos];
          this.#setActive(next);
        }, interval);
      }

      #stopCycle() {
        if (this.#timer != null) {
          window.clearInterval(this.#timer);
          this.#timer = null;
        }
      }
    }

    customElements.define('owt-color-changer', OwtColorChanger);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["owt-detail-viewer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('owt-detail-viewer')) return;

    class OwtDetailViewer extends HTMLElement {
      #stage = null;
      #heroMount = null;
      #heroFit = null;
      #heroImg = null;
      #zoomHit = null;
      #lens = null;
      #dialog = null;
      #dialogImg = null;
      #dialogViewport = null;
      #zoomSrc = '';
      #zoomLevel = 2;
      #finePointer = false;
      #reduceMotion = false;
      #resizeObserver = null;
      #layoutFrame = null;
      #lensFrame = null;
      #lensVisible = false;
      #pointerTap = { x: 0, y: 0, t: 0, moved: false, pointerId: null };
      #lastDialogTap = 0;

      #pinch = {
        scale: 1,
        min: 1,
        max: 4,
        lastDist: 0,
        panX: 0,
        panY: 0,
        startPanX: 0,
        startPanY: 0,
        startX: 0,
        startY: 0,
        active: false
      };

      connectedCallback() {
        this.#stage = this.querySelector('.owt-detail-viewer__stage');
        if (!this.#stage) return;

        this.#heroMount = this.#stage.querySelector('.owt-detail-viewer__hero-mount');
        this.#heroFit = this.#stage.querySelector('.owt-detail-viewer__hero-fit');
        this.#heroImg = this.#stage.querySelector('.owt-detail-viewer__hero-img');
        this.#zoomHit = this.#stage.querySelector('[data-zoom-hit]');
        this.#lens = this.#stage.querySelector('[data-lens]');

        const section = this.closest('.owt-detail-viewer');
        this.#dialog = section?.querySelector('[data-detail-dialog]') ?? null;
        this.#dialogImg = section?.querySelector('.owt-detail-viewer__dialog-img') ?? null;
        this.#dialogViewport = section?.querySelector('[data-detail-viewport]') ?? null;

        this.#zoomSrc = this.dataset.zoomSrc || '';
        const zoomRaw = parseFloat(this.dataset.zoomLevel || '20') || 20;
        this.#zoomLevel = zoomRaw > 5 ? zoomRaw / 10 : zoomRaw;
        this.#finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
        this.#reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const macroFallback = section?.querySelector('[data-macro-fallback]');
        if (this.#reduceMotion && macroFallback) {
          macroFallback.hidden = false;
        }

        this.#bindLayoutListeners();
        this.#scheduleLayout();

        if (this.#zoomSrc) {
          if (this.#lens) {
            this.#lens.style.backgroundImage = `url("${this.#zoomSrc}")`;
          }
          this.#initZoomSurface();
          if (!this.#reduceMotion) {
            if (this.#finePointer) {
              this.#initHoverLens();
            }
            this.#initTouchLens();
          }
          this.#initDialogTriggers();
        }
      }

      disconnectedCallback() {
        this.#resizeObserver?.disconnect();
        if (this.#layoutFrame != null) window.cancelAnimationFrame(this.#layoutFrame);
        if (this.#lensFrame != null) window.cancelAnimationFrame(this.#lensFrame);
      }

      #initDialogTriggers() {
        const section = this.closest('.owt-detail-viewer');
        const openers = [];
        if (section) {
          openers.push(...section.querySelectorAll('[data-detail-open]'));
        }

        for (const el of openers) {
          el.addEventListener('click', () => this.#openDialog());
        }

        if (this.#zoomHit) {
          this.#zoomHit.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              this.#openDialog();
            }
          });
          this.#zoomHit.addEventListener('click', (e) => {
            if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
            this.#openDialog();
          });
        }

        this.#dialog?.querySelector('[data-detail-close]')?.addEventListener('click', () => this.#closeDialog());
        this.#dialog?.addEventListener('click', (e) => {
          if (e.target === this.#dialog) this.#closeDialog();
        });
        this.#dialog?.addEventListener('cancel', (e) => {
          e.preventDefault();
          this.#closeDialog();
        });
      }

      #openDialog() {
        if (!this.#dialog || !this.#dialogImg) return;
        if (this.#dialog.open) return;
        if (this.#zoomSrc && !this.#dialogImg.getAttribute('src')) {
          this.#dialogImg.src = this.#zoomSrc;
        }
        this.#resetPinch();
        this.#dialog.showModal();
        this.#initPinchPan();
        this.#dialog.querySelector('[data-detail-close]')?.focus();
      }

      #closeDialog() {
        if (!this.#dialog?.open) return;
        this.#dialog.close();
        this.#teardownPinchPan();
      }

      #resetPinch() {
        this.#pinch.scale = 1;
        this.#pinch.panX = 0;
        this.#pinch.panY = 0;
        this.#applyPinchTransform();
      }

      #applyPinchTransform() {
        if (!this.#dialogImg) return;
        this.#dialogImg.style.transform = `translate(${this.#pinch.panX}px, ${this.#pinch.panY}px) scale(${this.#pinch.scale})`;
      }

      #initPinchPan() {
        const vp = this.#dialogViewport;
        if (!vp) return;

        this.#onTouchStart = (e) => this.#handleTouchStart(e);
        this.#onTouchMove = (e) => this.#handleTouchMove(e);
        this.#onTouchEnd = () => this.#handleTouchEnd();

        vp.addEventListener('touchstart', this.#onTouchStart, { passive: false });
        vp.addEventListener('touchmove', this.#onTouchMove, { passive: false });
        vp.addEventListener('touchend', (e) => {
          this.#handleTouchEnd();
          if (e.changedTouches.length === 1 && !this.#pinch.active) {
            const now = Date.now();
            if (now - this.#lastDialogTap < 320) {
              this.#pinch.scale = this.#pinch.scale > 1.5 ? 1 : Math.min(this.#pinch.max, 2.5);
              this.#applyPinchTransform();
              this.#lastDialogTap = 0;
            } else {
              this.#lastDialogTap = now;
            }
          }
        });
        vp.addEventListener('touchcancel', this.#onTouchEnd);
      }

      #teardownPinchPan() {
        const vp = this.#dialogViewport;
        if (!vp || !this.#onTouchStart) return;
        vp.removeEventListener('touchstart', this.#onTouchStart);
        vp.removeEventListener('touchmove', this.#onTouchMove);
        vp.removeEventListener('touchend', this.#onTouchEnd);
        vp.removeEventListener('touchcancel', this.#onTouchEnd);
      }

      #onTouchStart = null;
      #onTouchMove = null;
      #onTouchEnd = null;

      #touchDistance(touches) {
        if (touches.length < 2) return 0;
        const dx = touches[0].clientX - touches[1].clientX;
        const dy = touches[0].clientY - touches[1].clientY;
        return Math.hypot(dx, dy);
      }

      #handleTouchStart(e) {
        const touches = e.touches;
        if (touches.length === 2) {
          this.#pinch.active = true;
          this.#pinch.lastDist = this.#touchDistance(touches);
          e.preventDefault();
        } else if (touches.length === 1 && this.#pinch.scale > 1) {
          this.#pinch.startX = touches[0].clientX;
          this.#pinch.startY = touches[0].clientY;
          this.#pinch.startPanX = this.#pinch.panX;
          this.#pinch.startPanY = this.#pinch.panY;
          e.preventDefault();
        }
      }

      #handleTouchMove(e) {
        const touches = e.touches;
        if (touches.length === 2 && this.#pinch.active) {
          const dist = this.#touchDistance(touches);
          if (this.#pinch.lastDist > 0) {
            const next = this.#pinch.scale * (dist / this.#pinch.lastDist);
            this.#pinch.scale = Math.min(this.#pinch.max, Math.max(this.#pinch.min, next));
            this.#applyPinchTransform();
          }
          this.#pinch.lastDist = dist;
          e.preventDefault();
        } else if (touches.length === 1 && this.#pinch.scale > 1) {
          this.#pinch.panX = this.#pinch.startPanX + (touches[0].clientX - this.#pinch.startX);
          this.#pinch.panY = this.#pinch.startPanY + (touches[0].clientY - this.#pinch.startY);
          this.#applyPinchTransform();
          e.preventDefault();
        }
      }

      #handleTouchEnd() {
        this.#pinch.active = false;
        this.#pinch.lastDist = 0;
        if (this.#pinch.scale <= 1.02) {
          this.#resetPinch();
        }
      }

      #initZoomSurface() {
        if (!this.#zoomHit || !this.#heroImg) return;
        this.#zoomHit.hidden = false;
        this.#zoomHit.setAttribute('tabindex', '0');
        this.#positionZoomHit();
      }

      #showLens() {
        if (!this.#lens) return;
        this.#lensVisible = true;
        this.#lens.hidden = false;
        this.#lens.classList.add('is-active');
        this.#lens.setAttribute('aria-hidden', 'false');
      }

      #hideLens() {
        if (!this.#lens) return;
        this.#lensVisible = false;
        this.#lens.hidden = true;
        this.#lens.classList.remove('is-active');
        this.#lens.setAttribute('aria-hidden', 'true');
      }

      #initHoverLens() {
        if (!this.#zoomHit || !this.#lens || !this.#heroImg) return;

        this.#zoomHit.addEventListener('pointerenter', (e) => {
          if (e.pointerType !== 'mouse') return;
          this.#showLens();
        });
        this.#zoomHit.addEventListener('pointerleave', (e) => {
          if (e.pointerType !== 'mouse') return;
          this.#hideLens();
        });
        this.#zoomHit.addEventListener('pointermove', (e) => {
          if (e.pointerType !== 'mouse' || !this.#lensVisible) return;
          this.#moveLens(e);
        });
      }

      #initTouchLens() {
        if (!this.#zoomHit || !this.#lens || !this.#heroImg) return;

        this.#zoomHit.addEventListener('pointerdown', (e) => {
          if (e.pointerType === 'mouse' && this.#finePointer) return;
          this.#pointerTap = {
            x: e.clientX,
            y: e.clientY,
            t: Date.now(),
            moved: false,
            pointerId: e.pointerId
          };
          this.#showLens();
          this.#moveLens(e);
          this.#zoomHit.setPointerCapture(e.pointerId);
        });

        this.#zoomHit.addEventListener('pointermove', (e) => {
          if (this.#pointerTap.pointerId !== e.pointerId) return;
          if (Math.hypot(e.clientX - this.#pointerTap.x, e.clientY - this.#pointerTap.y) > 10) {
            this.#pointerTap.moved = true;
          }
          this.#moveLens(e);
        });

        const endTouchPointer = (e) => {
          if (this.#pointerTap.pointerId !== e.pointerId) return;
          this.#hideLens();
          try {
            this.#zoomHit.releasePointerCapture(e.pointerId);
          } catch {
            /* pointer already released */
          }
          if (!this.#pointerTap.moved && Date.now() - this.#pointerTap.t < 450) {
            this.#openDialog();
          }
          this.#pointerTap.pointerId = null;
        };

        this.#zoomHit.addEventListener('pointerup', endTouchPointer);
        this.#zoomHit.addEventListener('pointercancel', endTouchPointer);
      }

      #moveLens(e) {
        if (!this.#lensVisible || !this.#lens || !this.#zoomHit) return;
        if (this.#lensFrame != null) window.cancelAnimationFrame(this.#lensFrame);
        this.#lensFrame = window.requestAnimationFrame(() => {
          this.#lensFrame = null;
          const stageRect = this.#stage.getBoundingClientRect();
          const hitRect = this.#zoomHit.getBoundingClientRect();
          const lensSize = this.#lens.offsetWidth || 160;
          const half = lensSize / 2;

          let left = e.clientX - stageRect.left - half;
          let top = e.clientY - stageRect.top - half;
          const maxLeft = stageRect.width - lensSize;
          const maxTop = stageRect.height - lensSize;
          left = Math.max(0, Math.min(maxLeft, left));
          top = Math.max(0, Math.min(maxTop, top));

          this.#lens.style.left = `${left}px`;
          this.#lens.style.top = `${top}px`;

          const px = ((e.clientX - hitRect.left) / hitRect.width) * 100;
          const py = ((e.clientY - hitRect.top) / hitRect.height) * 100;
          const bgSize = this.#zoomLevel * 100;
          this.#lens.style.backgroundSize = `${bgSize}%`;
          this.#lens.style.backgroundPosition = `${px}% ${py}%`;
        });
      }

      #positionZoomHit() {
        if (!this.#zoomHit || !this.#heroImg) return;
        const img = this.#heroImg;
        if (!img.complete) {
          img.addEventListener('load', () => this.#positionZoomHit(), { once: true });
          return;
        }
        const stageRect = this.#stage.getBoundingClientRect();
        const imgRect = img.getBoundingClientRect();
        if (imgRect.width <= 0 || imgRect.height <= 0) return;

        this.#zoomHit.style.left = `${imgRect.left - stageRect.left}px`;
        this.#zoomHit.style.top = `${imgRect.top - stageRect.top}px`;
        this.#zoomHit.style.width = `${imgRect.width}px`;
        this.#zoomHit.style.height = `${imgRect.height}px`;
        this.#zoomHit.hidden = false;
      }

      #bindLayoutListeners() {
        window.addEventListener('resize', () => this.#scheduleLayout(), { passive: true });
        if (typeof ResizeObserver !== 'undefined') {
          this.#resizeObserver = new ResizeObserver(() => this.#scheduleLayout());
          this.#resizeObserver.observe(this.#stage);
          const stageWrap = this.closest('.owt-detail-viewer__stage-wrap');
          if (stageWrap) this.#resizeObserver.observe(stageWrap);
          const grid = this.closest('.owt-detail-viewer__grid');
          if (grid) this.#resizeObserver.observe(grid);
        }
        if (this.#heroImg instanceof HTMLImageElement && !this.#heroImg.complete) {
          this.#heroImg.addEventListener('load', () => this.#scheduleLayout(), { once: true });
        }
      }

      #scheduleLayout() {
        if (this.#layoutFrame != null) window.cancelAnimationFrame(this.#layoutFrame);
        this.#layoutFrame = window.requestAnimationFrame(() => {
          this.#layoutFrame = window.requestAnimationFrame(() => {
            this.#layoutFrame = null;
            this.#positionZoomHit();
          });
        });
      }
    }

    customElements.define('owt-detail-viewer', OwtDetailViewer);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["owt-display-visual"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('owt-display-visual')) return;

    const OWT_DV_ANIM_CLASSES = [
      'owt-display-visual__hero-img--settled',
      'owt-display-visual__hero-img--fade-in',
      'owt-display-visual__hero-img--grow',
      'owt-display-visual__hero-img--shrink',
      'owt-display-visual__hero-img--rise',
      'owt-display-visual__hero-img--fall',
      'owt-display-visual__hero-img--falling',
      'owt-display-visual__hero-img--slide-left',
      'owt-display-visual__hero-img--slide-right'
    ];

    const OWT_DV_EXIT_CLASSES = [
      'owt-display-visual__hero-img--fade-out',
      'owt-display-visual__hero-img--grow-out',
      'owt-display-visual__hero-img--shrink-out',
      'owt-display-visual__hero-img--rise-out',
      'owt-display-visual__hero-img--fall-out',
      'owt-display-visual__hero-img--falling-out',
      'owt-display-visual__hero-img--slide-left-out',
      'owt-display-visual__hero-img--slide-right-out'
    ];

    class OwtDisplayVisual extends HTMLElement {
      #stage = null;
      #imgs = [];
      #buttons = [];
      #valid = [];
      #active = 0;
      #timer = null;
      #cyclePos = 0;
      #paused = false;
      #reduceMotion = false;
      #liveRegion = null;
      #settleTimer = null;
      #exitTimer = null;
      #animEndHandler = null;
      #exitEndHandler = null;
      #onPointerEnter = null;
      #onPointerLeave = null;
      #onVisibility = null;

      connectedCallback() {
        this.#stage = this.querySelector('.owt-display-visual__stage');
        if (!this.#stage) return;

        this.#reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.#imgs = Array.from(this.#stage.querySelectorAll('.owt-display-visual__hero-img[data-display-index]'));
        this.#buttons = Array.from(this.querySelectorAll('.owt-display-visual__display-btn[data-display-index]'));
        this.#liveRegion = this.querySelector('[data-live-region]');
        this.#valid = this.#imgs
          .map((img) => parseInt(img.getAttribute('data-display-index'), 10))
          .filter((n) => !Number.isNaN(n))
          .sort((a, b) => a - b);

        if (this.#valid.length === 0) return;

        let initial = parseInt(this.dataset.initialIndex || '0', 10);
        if (!this.#valid.includes(initial)) {
          initial = this.#valid[0];
        }
        this.#active = initial;
        this.#cyclePos = Math.max(0, this.#valid.indexOf(initial));

        this.#syncImages(false);
        this.#syncButtons();
        this.#syncGlow();
        this.#updateLiveRegion();

        for (const btn of this.#buttons) {
          btn.addEventListener('click', this.#onDisplayClick);
          btn.addEventListener('pointerenter', this.#onDisplayPointerEnter);
        }

        this.#onPointerEnter = () => {
          this.#paused = true;
          this.#stopCycle();
        };
        this.#onPointerLeave = () => {
          this.#paused = false;
          this.#maybeStartCycle();
        };
        this.addEventListener('pointerenter', this.#onPointerEnter);
        this.addEventListener('pointerleave', this.#onPointerLeave);

        this.#onVisibility = () => {
          if (document.hidden) {
            this.#stopCycle();
          } else {
            this.#maybeStartCycle();
          }
        };
        document.addEventListener('visibilitychange', this.#onVisibility);

        this.#maybeStartCycle();
      }

      disconnectedCallback() {
        this.#stopCycle();
        this.#clearSettle();
        this.#clearExit();
        for (const btn of this.#buttons) {
          btn.removeEventListener('click', this.#onDisplayClick);
          btn.removeEventListener('pointerenter', this.#onDisplayPointerEnter);
        }
        if (this.#onPointerEnter) {
          this.removeEventListener('pointerenter', this.#onPointerEnter);
        }
        if (this.#onPointerLeave) {
          this.removeEventListener('pointerleave', this.#onPointerLeave);
        }
        if (this.#onVisibility) {
          document.removeEventListener('visibilitychange', this.#onVisibility);
        }
      }

      #onDisplayClick = (event) => {
        const btn = event.currentTarget;
        if (!(btn instanceof HTMLButtonElement) || btn.disabled) return;
        const index = parseInt(btn.getAttribute('data-display-index'), 10);
        if (Number.isNaN(index) || !this.#valid.includes(index)) return;
        this.#cyclePos = this.#valid.indexOf(index);
        this.#setActive(index);
        this.#paused = true;
        this.#stopCycle();
        window.setTimeout(() => {
          this.#paused = false;
          this.#maybeStartCycle();
        }, 4000);
      };

      #onDisplayPointerEnter = (event) => {
        if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
        const btn = event.currentTarget;
        if (!(btn instanceof HTMLButtonElement) || btn.disabled) return;
        const index = parseInt(btn.getAttribute('data-display-index'), 10);
        if (Number.isNaN(index) || !this.#valid.includes(index)) return;
        this.#setActive(index);
      };

      #setActive(index) {
        if (!this.#valid.includes(index)) return;
        const prev = this.#active;
        if (prev === index) return;
        this.#active = index;
        this.#cyclePos = Math.max(0, this.#valid.indexOf(index));
        this.#syncImages(!this.#reduceMotion, prev);
        this.#syncButtons();
        this.#syncGlow();
        this.#updateLiveRegion();
      }

      #syncImages(animate, prevIndex) {
        const fade = this.#stage.dataset.fadeDuration || '280';
        const displayOn = this.#stage.dataset.displayAnimation === 'true';
        const displayExit = this.#stage.dataset.displayExit === 'true';
        const displayStyle = this.#stage.dataset.displayStyle || 'slide_left';
        const displayMsRaw = this.#stage.dataset.displayMs || '520';
        const displayMs = Number.parseInt(displayMsRaw, 10);
        const displayMsSafe = Number.isNaN(displayMs) ? 520 : displayMs;
        this.#stage.style.setProperty('--owt-dv-fade', animate ? `${fade}ms` : '0ms');
        this.#stage.style.setProperty('--owt-dv-display-ms', `${displayMsSafe}ms`);

        const direction =
          typeof prevIndex === 'number' && prevIndex !== this.#active
            ? this.#active > prevIndex
              ? 'grow'
              : 'shrink'
            : 'none';

        const prevImg =
          typeof prevIndex === 'number'
            ? this.#imgs.find(
                (img) => parseInt(img.getAttribute('data-display-index'), 10) === prevIndex
              )
            : null;

        const activeImg = this.#imgs.find((img) => {
          const idx = parseInt(img.getAttribute('data-display-index'), 10);
          return idx === this.#active;
        });

        this.#clearSettle();
        this.#clearExit();

        const instant = !animate || this.#reduceMotion;
        const useDisplayAnim = displayOn && animate && !this.#reduceMotion;
        const useExit =
          useDisplayAnim && displayExit && prevImg && prevImg !== activeImg;

        const stripClasses = [...OWT_DV_ANIM_CLASSES, ...OWT_DV_EXIT_CLASSES, 'is-leaving'];

        for (const img of this.#imgs) {
          if (useExit && img === prevImg) {
            img.classList.remove(...OWT_DV_ANIM_CLASSES, 'owt-display-visual__hero-img--settled', 'is-leaving');
            continue;
          }
          img.classList.remove('is-active', ...stripClasses);
        }

        if (!activeImg) {
          if (prevImg) {
            prevImg.classList.remove('is-active', ...stripClasses);
          }
          window.requestAnimationFrame(() => {
            this.#stage.style.setProperty('--owt-dv-fade', `${fade}ms`);
          });
          return;
        }

        if (useExit) {
          this.#runExitAnimation(prevImg, displayStyle, direction, displayMsSafe);
        } else if (prevImg) {
          prevImg.classList.remove('is-active', ...stripClasses);
        }

        if (instant) {
          activeImg.classList.add('is-active', 'owt-display-visual__hero-img--settled');
        } else if (useDisplayAnim) {
          this.#runDisplayAnimation(activeImg, displayStyle, direction, displayMsSafe);
        } else {
          activeImg.classList.add('is-active', 'owt-display-visual__hero-img--settled');
        }

        window.requestAnimationFrame(() => {
          this.#stage.style.setProperty('--owt-dv-fade', `${fade}ms`);
        });
      }

      #clearSettle() {
        if (this.#settleTimer != null) {
          window.clearTimeout(this.#settleTimer);
          this.#settleTimer = null;
        }
        if (this.#animEndHandler) {
          for (const img of this.#imgs) {
            img.removeEventListener('animationend', this.#animEndHandler);
          }
          this.#animEndHandler = null;
        }
      }

      #clearExit() {
        if (this.#exitTimer != null) {
          window.clearTimeout(this.#exitTimer);
          this.#exitTimer = null;
        }
        if (this.#exitEndHandler) {
          for (const img of this.#imgs) {
            img.removeEventListener('animationend', this.#exitEndHandler);
          }
          this.#exitEndHandler = null;
        }
      }

      #finishExit(prevImg) {
        if (!prevImg) return;
        prevImg.classList.remove('is-active', 'is-leaving', ...OWT_DV_EXIT_CLASSES);
      }

      #runExitAnimation(prevImg, displayStyle, direction, displayMs) {
        prevImg.classList.add('is-leaving');
        this.#applyDisplayExitClass(prevImg, displayStyle, direction);
        void prevImg.offsetWidth;

        const finish = () => {
          this.#finishExit(prevImg);
          this.#clearExit();
        };

        this.#exitEndHandler = (event) => {
          if (event.target !== prevImg) return;
          if (event.pseudoElement) return;
          finish();
        };
        prevImg.addEventListener('animationend', this.#exitEndHandler);
        this.#exitTimer = window.setTimeout(finish, displayMs + 80);
      }

      #settleActiveImg(activeImg) {
        if (!activeImg) return;
        if (parseInt(activeImg.getAttribute('data-display-index'), 10) !== this.#active) return;
        activeImg.classList.add('owt-display-visual__hero-img--settled');
      }

      #runDisplayAnimation(activeImg, displayStyle, direction, displayMs) {
        this.#applyDisplayAnimClass(activeImg, displayStyle, direction);

        const startAnim = () => {
          void activeImg.offsetWidth;
          activeImg.classList.add('is-active');

          const settleMs = Number.isNaN(displayMs) ? 520 : displayMs;
          this.#animEndHandler = (event) => {
            if (event.target !== activeImg) return;
            if (event.pseudoElement) return;
            this.#settleActiveImg(activeImg);
            this.#clearSettle();
          };
          activeImg.addEventListener('animationend', this.#animEndHandler);
          this.#settleTimer = window.setTimeout(() => {
            this.#settleActiveImg(activeImg);
            this.#clearSettle();
          }, settleMs + 80);
        };

        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(startAnim);
        });
      }

      #applyDisplayAnimClass(activeImg, displayStyle, direction) {
        switch (displayStyle) {
          case 'fade_up':
            activeImg.classList.add('owt-display-visual__hero-img--rise');
            break;
          case 'fade_down':
            activeImg.classList.add('owt-display-visual__hero-img--fall');
            break;
          case 'falling':
            activeImg.classList.add('owt-display-visual__hero-img--falling');
            break;
          case 'slide_left':
            activeImg.classList.add('owt-display-visual__hero-img--slide-left');
            break;
          case 'slide_right':
            activeImg.classList.add('owt-display-visual__hero-img--slide-right');
            break;
          case 'slide_directional':
            if (direction === 'grow') {
              activeImg.classList.add('owt-display-visual__hero-img--slide-right');
            } else if (direction === 'shrink') {
              activeImg.classList.add('owt-display-visual__hero-img--slide-left');
            } else {
              activeImg.classList.add('owt-display-visual__hero-img--slide-left');
            }
            break;
          case 'scale':
            if (direction === 'grow') {
              activeImg.classList.add('owt-display-visual__hero-img--grow');
            } else if (direction === 'shrink') {
              activeImg.classList.add('owt-display-visual__hero-img--shrink');
            } else {
              activeImg.classList.add('owt-display-visual__hero-img--fade-in');
            }
            break;
          case 'fade':
            activeImg.classList.add('owt-display-visual__hero-img--fade-in');
            break;
          default:
            activeImg.classList.add('owt-display-visual__hero-img--fade-in');
            break;
        }
      }

      #applyDisplayExitClass(prevImg, displayStyle, direction) {
        switch (displayStyle) {
          case 'fade_up':
            prevImg.classList.add('owt-display-visual__hero-img--rise-out');
            break;
          case 'fade_down':
            prevImg.classList.add('owt-display-visual__hero-img--fall-out');
            break;
          case 'falling':
            prevImg.classList.add('owt-display-visual__hero-img--falling-out');
            break;
          case 'slide_left':
            prevImg.classList.add('owt-display-visual__hero-img--slide-left-out');
            break;
          case 'slide_right':
            prevImg.classList.add('owt-display-visual__hero-img--slide-right-out');
            break;
          case 'slide_directional':
            if (direction === 'grow') {
              prevImg.classList.add('owt-display-visual__hero-img--slide-left-out');
            } else if (direction === 'shrink') {
              prevImg.classList.add('owt-display-visual__hero-img--slide-right-out');
            } else {
              prevImg.classList.add('owt-display-visual__hero-img--slide-left-out');
            }
            break;
          case 'scale':
            if (direction === 'grow') {
              prevImg.classList.add('owt-display-visual__hero-img--shrink-out');
            } else if (direction === 'shrink') {
              prevImg.classList.add('owt-display-visual__hero-img--grow-out');
            } else {
              prevImg.classList.add('owt-display-visual__hero-img--fade-out');
            }
            break;
          case 'fade':
          default:
            prevImg.classList.add('owt-display-visual__hero-img--fade-out');
            break;
        }
      }

      #syncGlow() {
        if (!this.#stage.classList.contains('owt-display-visual__stage--glow')) return;
        this.#stage.classList.add('owt-display-visual__stage--glow-on');
      }

      #syncButtons() {
        for (const btn of this.#buttons) {
          const index = parseInt(btn.getAttribute('data-display-index'), 10);
          const pressed =
            !btn.disabled && this.#valid.includes(index) && index === this.#active;
          btn.setAttribute('aria-pressed', pressed ? 'true' : 'false');
        }
      }

      #updateLiveRegion() {
        if (!this.#liveRegion) return;
        const activeBtn = this.#buttons.find(
          (btn) => parseInt(btn.getAttribute('data-display-index'), 10) === this.#active
        );
        if (!activeBtn) return;
        const label = activeBtn.getAttribute('aria-label') || activeBtn.textContent || '';
        this.#liveRegion.textContent = label.trim();
      }

      #maybeStartCycle() {
        this.#stopCycle();
        if (this.#paused || document.hidden) return;
        if (this.dataset.autoCycle !== 'true') return;
        if (this.#reduceMotion) return;
        if (this.#valid.length < 2) return;

        const interval = parseInt(this.dataset.cycleInterval || '3200', 10);
        if (Number.isNaN(interval) || interval < 1200) return;

        this.#timer = window.setInterval(() => {
          if (this.#paused || document.hidden) return;
          this.#cyclePos = (this.#cyclePos + 1) % this.#valid.length;
          this.#setActive(this.#valid[this.#cyclePos]);
        }, interval);
      }

      #stopCycle() {
        if (this.#timer != null) {
          window.clearInterval(this.#timer);
          this.#timer = null;
        }
      }
    }

    customElements.define('owt-display-visual', OwtDisplayVisual);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["owt-size-changer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('owt-size-changer')) return;

    class OwtSizeChanger extends HTMLElement {
      #stage = null;
      #cakeMount = null;
      #cakeFit = null;
      #cakeUnit = null;
      #imgs = [];
      #buttons = [];
      #valid = [];
      #active = 0;
      #timer = null;
      #cyclePos = 0;
      #paused = false;
      #reduceMotion = false;
      #resizeObserver = null;
      #fitFrame = null;
      #onPointerEnter = null;
      #onPointerLeave = null;
      #onVisibility = null;

      connectedCallback() {
        this.#stage = this.querySelector('.owt-size-changer__stage');
        if (!this.#stage) return;

        this.#cakeMount = this.#stage.querySelector('.owt-size-changer__cake-mount');
        this.#cakeFit = this.#stage.querySelector('.owt-size-changer__cake-fit');
        this.#cakeUnit = this.#stage.querySelector('.owt-size-changer__cake-unit');

        this.#reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.#imgs = Array.from(this.#stage.querySelectorAll('.owt-size-changer__topper-img[data-topper-index]'));
        this.#buttons = Array.from(this.querySelectorAll('.owt-size-changer__size-btn[data-size-index]'));
        this.#valid = this.#imgs
          .map((img) => parseInt(img.getAttribute('data-topper-index'), 10))
          .filter((n) => !Number.isNaN(n))
          .sort((a, b) => a - b);

        if (this.#valid.length === 0) return;

        let initial = parseInt(this.dataset.initialIndex || '1', 10);
        if (!this.#valid.includes(initial)) {
          initial = this.#valid[0];
        }
        this.#active = initial;
        this.#cyclePos = Math.max(0, this.#valid.indexOf(initial));

        this.#syncImages(false);
        this.#syncButtons();
        this.#updateLiveRegion();

        for (const btn of this.#buttons) {
          btn.addEventListener('click', this.#onSizeClick);
        }

        if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
          for (const btn of this.#buttons) {
            btn.addEventListener('pointerenter', this.#onSizePointerEnter);
          }
        }

        this.#onPointerEnter = () => {
          this.#paused = true;
          this.#stopCycle();
        };
        this.#onPointerLeave = () => {
          this.#paused = false;
          this.#maybeStartCycle();
        };
        this.addEventListener('pointerenter', this.#onPointerEnter);
        this.addEventListener('pointerleave', this.#onPointerLeave);

        this.#onVisibility = () => {
          if (document.hidden) {
            this.#stopCycle();
          } else {
            this.#maybeStartCycle();
          }
        };
        document.addEventListener('visibilitychange', this.#onVisibility);

        this.#bindFitListeners();
        this.#scheduleFit();

        this.#maybeStartCycle();
      }

      disconnectedCallback() {
        this.#stopCycle();
        if (this.#fitFrame != null) {
          window.cancelAnimationFrame(this.#fitFrame);
          this.#fitFrame = null;
        }
        if (this.#resizeObserver) {
          this.#resizeObserver.disconnect();
          this.#resizeObserver = null;
        }
        if (this.#onPointerEnter && this.#onPointerLeave) {
          this.removeEventListener('pointerenter', this.#onPointerEnter);
          this.removeEventListener('pointerleave', this.#onPointerLeave);
        }
        if (this.#onVisibility) {
          document.removeEventListener('visibilitychange', this.#onVisibility);
        }
        for (const btn of this.#buttons) {
          btn.removeEventListener('click', this.#onSizeClick);
          btn.removeEventListener('pointerenter', this.#onSizePointerEnter);
        }
      }

      #onSizeClick = (e) => {
        const btn = e.currentTarget;
        const idx = parseInt(btn.getAttribute('data-size-index'), 10);
        if (Number.isNaN(idx)) return;
        if (!this.#valid.includes(idx)) return;
        this.#cyclePos = this.#valid.indexOf(idx);
        this.#setActive(idx);
      };

      #onSizePointerEnter = (e) => {
        const btn = e.currentTarget;
        const idx = parseInt(btn.getAttribute('data-size-index'), 10);
        if (Number.isNaN(idx)) return;
        if (!this.#valid.includes(idx)) return;
        this.#setActive(idx);
      };

      #setActive(index) {
        if (this.#active === index && this.#imgs.some((img) => img.classList.contains('is-active'))) return;
        const prev = this.#active;
        this.#active = index;
        this.#syncImages(!this.#reduceMotion, prev);
        this.#syncButtons();
        this.#updateLiveRegion();
      }

      #syncImages(animate, prevIndex) {
        const fade = this.#stage.dataset.fadeDuration || '280';
        const sizeOn = this.#stage.dataset.sizeAnimation === 'true';
        const sizeMsRaw = this.#stage.dataset.sizeMs || '520';
        const sizeMs = Number.parseInt(sizeMsRaw, 10);
        this.#stage.style.setProperty('--owt-sc-fade', animate ? `${fade}ms` : '0ms');
        this.#stage.style.setProperty('--owt-sc-size-ms', `${Number.isNaN(sizeMs) ? 520 : sizeMs}ms`);

        const direction =
          typeof prevIndex === 'number' && prevIndex !== this.#active
            ? this.#active > prevIndex
              ? 'grow'
              : 'shrink'
            : 'none';

        for (const img of this.#imgs) {
          img.classList.remove(
            'is-active',
            'owt-size-changer__topper-img--settled',
            'owt-size-changer__topper-img--grow',
            'owt-size-changer__topper-img--shrink'
          );
        }

        const activeImg = this.#imgs.find((img) => {
          const idx = parseInt(img.getAttribute('data-topper-index'), 10);
          return idx === this.#active;
        });

        if (!activeImg) {
          window.requestAnimationFrame(() => {
            this.#stage.style.setProperty('--owt-sc-fade', `${fade}ms`);
          });
          return;
        }

        const instant = !animate || this.#reduceMotion;
        const useSizeAnim = sizeOn && animate && !this.#reduceMotion;

        if (instant) {
          activeImg.classList.add('is-active', 'owt-size-changer__topper-img--settled');
        } else if (useSizeAnim) {
          if (direction === 'grow') {
            activeImg.classList.add('owt-size-changer__topper-img--grow');
          } else if (direction === 'shrink') {
            activeImg.classList.add('owt-size-changer__topper-img--shrink');
          }
          void activeImg.offsetWidth;
          activeImg.classList.add('is-active');
        } else {
          activeImg.classList.add('is-active');
        }

        if (useSizeAnim && !instant) {
          const settleMs = Number.isNaN(sizeMs) ? 520 : sizeMs;
          window.setTimeout(() => {
            if (parseInt(activeImg.getAttribute('data-topper-index'), 10) === this.#active) {
              activeImg.classList.add('owt-size-changer__topper-img--settled');
            }
            this.#scheduleFit();
          }, settleMs);
        } else if (!instant) {
          activeImg.classList.add('owt-size-changer__topper-img--settled');
        }

        window.requestAnimationFrame(() => {
          this.#stage.style.setProperty('--owt-sc-fade', `${fade}ms`);
        });

        this.#scheduleFit();
      }

      #bindFitListeners() {
        if (!this.#cakeMount || !this.#cakeFit || !this.#cakeUnit) return;

        const onAssetReady = () => this.#scheduleFit();
        const cakeImg = this.#cakeUnit.querySelector('.owt-size-changer__cake-img');
        if (cakeImg instanceof HTMLImageElement) {
          if (cakeImg.complete) {
            onAssetReady();
          } else {
            cakeImg.addEventListener('load', onAssetReady, { once: true });
          }
        }

        for (const img of this.#imgs) {
          if (img.complete) {
            if (typeof img.decode === 'function') {
              img.decode().then(onAssetReady).catch(onAssetReady);
            }
            continue;
          }
          img.addEventListener('load', onAssetReady, { once: true });
          if (typeof img.decode === 'function') {
            img.decode().then(onAssetReady).catch(() => {});
          }
        }

        window.addEventListener('load', onAssetReady, { once: true });

        if (typeof ResizeObserver !== 'undefined') {
          this.#resizeObserver = new ResizeObserver(() => this.#scheduleFit());
          this.#resizeObserver.observe(this.#stage);
          const stageWrap = this.closest('.owt-size-changer__stage-wrap');
          if (stageWrap) this.#resizeObserver.observe(stageWrap);
        }
      }

      #scheduleFit() {
        if (this.#fitFrame != null) {
          window.cancelAnimationFrame(this.#fitFrame);
        }
        this.#fitFrame = window.requestAnimationFrame(() => {
          this.#fitFrame = window.requestAnimationFrame(() => {
            this.#fitFrame = null;
            this.#fitToMount();
          });
        });
      }

      #contentMetrics(cakeDisplayW, cakeAspect, activeImg, anchorPct) {
        const cakeH = cakeDisplayW * cakeAspect;
        let totalH = cakeH;
        let totalW = cakeDisplayW;

        if (activeImg instanceof HTMLImageElement) {
          const topperNW =
            parseInt(activeImg.getAttribute('data-native-width'), 10) || activeImg.naturalWidth || 0;
          const topperNH =
            parseInt(activeImg.getAttribute('data-native-height'), 10) || activeImg.naturalHeight || 0;
          const topperPct = parseFloat(activeImg.style.width) / 100 || 0;

          if (topperNW > 0 && topperNH > 0 && topperPct > 0) {
            const topperW = cakeDisplayW * topperPct;
            const topperH = topperW * (topperNH / topperNW);
            const mountFromBottom = anchorPct * cakeH;
            totalH = Math.max(cakeH, mountFromBottom + topperH);
            totalW = Math.max(cakeDisplayW, topperW);
          }
        }

        return { totalH, totalW };
      }

      #readAnchorPct() {
        const raw = window.getComputedStyle(this.#stage).getPropertyValue('--owt-sc-topper-anchor').trim();
        const parsed = parseFloat(raw);
        if (Number.isNaN(parsed)) return 0.88;
        return parsed > 1 ? parsed / 100 : parsed;
      }

      #fitToMount() {
        const stage = this.#stage;
        const fit = this.#cakeFit;
        const unit = this.#cakeUnit;
        if (!stage || !fit || !unit) return;

        const availW = stage.clientWidth;
        const availH = stage.clientHeight;
        if (availW <= 0 || availH <= 0) return;

        const cakeImg = unit.querySelector('.owt-size-changer__cake-img');
        const activeImg = this.#imgs.find((img) => {
          const idx = parseInt(img.getAttribute('data-topper-index'), 10);
          return idx === this.#active;
        });

        if (activeImg instanceof HTMLImageElement && !activeImg.complete) {
          activeImg.addEventListener('load', () => this.#scheduleFit(), { once: true });
          return;
        }

        const margin = 0.96;
        const anchorPct = this.#readAnchorPct();
        let scale = 1;

        if (cakeImg instanceof HTMLImageElement) {
          if (!cakeImg.complete) {
            cakeImg.addEventListener('load', () => this.#scheduleFit(), { once: true });
            return;
          }

          const cakeNW = cakeImg.naturalWidth || parseInt(cakeImg.getAttribute('width'), 10) || 0;
          const cakeNH = cakeImg.naturalHeight || parseInt(cakeImg.getAttribute('height'), 10) || 0;
          if (cakeNW <= 0 || cakeNH <= 0) return;

          const mountW = this.#cakeMount?.clientWidth || availW;
          const cakeDisplayW =
            cakeImg.clientWidth > 0 ? cakeImg.clientWidth : Math.min(cakeNW, mountW);
          const cakeAspect = cakeNH / cakeNW;
          const metrics = this.#contentMetrics(cakeDisplayW, cakeAspect, activeImg, anchorPct);

          if (metrics.totalH <= 0 || metrics.totalW <= 0) return;

          scale = Math.min(1, (availH * margin) / metrics.totalH, (availW * margin) / metrics.totalW);
        } else {
          stage.style.setProperty('--owt-sc-fit-scale', '1');
          void fit.offsetHeight;

          const unitRect = unit.getBoundingClientRect();
          let topEdge = unitRect.top;
          let maxW = unitRect.width;

          if (activeImg instanceof HTMLImageElement) {
            const topperRect = activeImg.getBoundingClientRect();
            if (topperRect.height > 0) {
              topEdge = Math.min(topEdge, topperRect.top);
              maxW = Math.max(maxW, topperRect.width);
            }
          }

          const contentH = unitRect.bottom - topEdge;
          if (contentH <= 0 || maxW <= 0) return;

          scale = Math.min(1, (availH * margin) / contentH, (availW * margin) / maxW);
        }

        const rounded = Math.max(0.05, Math.min(1, Math.floor(scale * 1000) / 1000));
        stage.style.setProperty('--owt-sc-fit-scale', String(rounded));

        window.requestAnimationFrame(() => {
          const unitRect = unit.getBoundingClientRect();
          const stageRect = stage.getBoundingClientRect();
          const overflowTop = unitRect.top - stageRect.top;
          const overflowBottom = stageRect.bottom - unitRect.bottom;

          if (overflowTop < -1 || overflowBottom < -1) {
            const tighten = Math.min(
              availH / (unitRect.height || availH),
              availW / (unitRect.width || availW),
              1
            );
            if (tighten < 0.999) {
              const next = Math.max(0.05, Math.floor(rounded * tighten * 1000) / 1000);
              stage.style.setProperty('--owt-sc-fit-scale', String(next));
            }
          }
        });
      }

      #syncButtons() {
        for (const btn of this.#buttons) {
          const idx = parseInt(btn.getAttribute('data-size-index'), 10);
          const hasTopper = this.#valid.includes(idx);
          btn.hidden = !hasTopper;
          btn.setAttribute('aria-pressed', idx === this.#active ? 'true' : 'false');
        }
      }

      #updateLiveRegion() {
        const wrap = this.#stage.querySelector('[data-live-label]');
        if (!wrap) return;
        const live = wrap.querySelector('[data-live-region]');
        const activeBtn = this.#buttons.find((b) => parseInt(b.getAttribute('data-size-index'), 10) === this.#active);
        if (live && activeBtn) {
          live.textContent = activeBtn.getAttribute('aria-label') || '';
        }
      }

      #maybeStartCycle() {
        this.#stopCycle();
        if (this.#paused || document.hidden) return;
        if (this.dataset.autoCycle !== 'true') return;
        if (this.#reduceMotion) return;
        if (this.#valid.length < 2) return;

        const interval = parseInt(this.dataset.cycleInterval || '3000', 10);
        if (Number.isNaN(interval) || interval < 1200) return;

        this.#timer = window.setInterval(() => {
          if (this.#paused || document.hidden) return;
          this.#cyclePos = (this.#cyclePos + 1) % this.#valid.length;
          const next = this.#valid[this.#cyclePos];
          this.#setActive(next);
        }, interval);
      }

      #stopCycle() {
        if (this.#timer != null) {
          window.clearInterval(this.#timer);
          this.#timer = null;
        }
      }
    }

    customElements.define('owt-size-changer', OwtSizeChanger);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["owt-switch-size"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('owt-switch-size')) return;

    class OwtSwitchSize extends HTMLElement {
      #compare = null;
      #range = null;
      #dragging = false;
      #root = null;
      #stage = null;

      connectedCallback() {
        this.#compare = this.querySelector('.owt-switch-size__compare');
        this.#range = this.querySelector('.owt-switch-size__range');
        this.#root = this.closest('.owt-switch-size.distance') || this.closest('.owt-switch-size');
        this.#stage = this.closest('.owt-switch-size__stage');

        if (!this.#compare || !this.#range) return;

        const centerSlider = () => {
          this.#range.value = '50';
          this.#setPosition(50, true);
        };

        centerSlider();
        requestAnimationFrame(centerSlider);

        this.#range.addEventListener('input', () => {
          this.#setPosition(Number(this.#range.value), true);
        });

        this.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          const current = Number(this.#range.value);
          const step = event.shiftKey ? 10 : 2;
          const next = event.key === 'ArrowRight' ? current + step : current - step;
          this.#setPosition(next, true);
        });

        const dragSurface = this.#compare;

        dragSurface.addEventListener('pointerdown', (event) => {
          if (event.pointerType === 'mouse' && event.button !== 0) return;
          this.#dragging = true;
          dragSurface.classList.add('is-dragging');
          dragSurface.setPointerCapture(event.pointerId);
          this.#updateFromPointer(event);
        });

        dragSurface.addEventListener('pointermove', (event) => {
          if (!this.#dragging) return;
          if (event.cancelable) {
            event.preventDefault();
          }
          this.#updateFromPointer(event);
        });

        dragSurface.addEventListener('pointerup', (event) => {
          if (!this.#dragging) return;
          this.#dragging = false;
          dragSurface.classList.remove('is-dragging');
          if (dragSurface.hasPointerCapture(event.pointerId)) {
            dragSurface.releasePointerCapture(event.pointerId);
          }
        });

        dragSurface.addEventListener('pointercancel', () => {
          this.#dragging = false;
          dragSurface.classList.remove('is-dragging');
        });
      }

      #updateFromPointer(event) {
        const rect = this.#compare.getBoundingClientRect();
        if (rect.width <= 0) return;
        const pct = ((event.clientX - rect.left) / rect.width) * 100;
        this.#setPosition(pct, true);
      }

      #setPosition(pct, syncRange) {
        const clamped = Math.min(100, Math.max(0, pct));
        const value = Math.round(clamped);
        const pos = `${value}%`;

        this.#compare.style.setProperty('--owt-ss-pos', pos);

        if (this.#root) {
          this.#root.style.setProperty('--owt-ss-pos', pos);
        }

        if (syncRange && this.#range) {
          this.#range.value = String(value);
        }

        this.setAttribute('aria-valuenow', String(value));
      }
    }

    customElements.define('owt-switch-size', OwtSwitchSize);

    const resetSwitchSizeCenter = (sectionEl) => {
      if (!sectionEl) return;
      const host = sectionEl.querySelector('owt-switch-size');
      const compare = sectionEl.querySelector('.owt-switch-size__compare');
      const range = sectionEl.querySelector('.owt-switch-size__range');
      if (!host || !compare || !range) return;

      range.value = '50';
      host.setAttribute('aria-valuenow', '50');
      sectionEl.style.setProperty('--owt-ss-pos', '50%');
      compare.style.setProperty('--owt-ss-pos', '50%');
    };

    document.addEventListener('shopify:section:load', (event) => {
      const sectionEl = event.target?.querySelector?.('.owt-switch-size.distance') || event.target?.closest?.('.section-owt-switch-size');
      if (!sectionEl) return;
      resetSwitchSizeCenter(sectionEl);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
